import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

const CallCentrumLanding = ({ t }) => (
  <div style={{ textAlign: 'center', marginTop: '3rem' }}>
    <p>{t('Vitajte v Majáku. Pre zobrazenie a úpravu dlžníkov je nutné navštíviť priamo adresu: ')}<code>{t('/admin/#/cc/<id klienta>')}</code></p>
  </div>
);

CallCentrumLanding.propTypes = {
  t: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default translate()(CallCentrumLanding);



// WEBPACK FOOTER //
// ./src/features/call-centrum/components/CallCentrumLanding.js